module.exports = "/static/assets/0b09fe426a0a8dec90cedaf030040d4f.png";